module.exports = __webpack_public_path__ + "img/calendar-minus-circle-red.3cf5d925.svg";